import { DeviceEnum } from "@/enums";
import { useEffect, useState } from "react";

/**
 * @function useBreakPoints
 * @description This function is used to get the device type
 */

const useBreakPoints = () => {
  const [deviceType, setDeviceType] = useState<string>(DeviceEnum.DESKTOP);

  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setDeviceType(DeviceEnum.MOBILE);
      } else if (window.innerWidth < 950 && window.innerWidth > 767) {
        setDeviceType(DeviceEnum.IPAD);
      } else if (window.innerWidth < 1600 && window.innerWidth > 1025) {
        setDeviceType(DeviceEnum.DESKTOP_SM);
      } else {
        setDeviceType(DeviceEnum.DESKTOP);
      }
    };

    const handlePointerChange = () => {
      setIsTouchDevice(window.matchMedia("(pointer: coarse)").matches);
    };

    window.addEventListener("resize", handleResize);
    window
      .matchMedia("(pointer: coarse)")
      .addEventListener("change", handlePointerChange);

    handleResize();
    handlePointerChange();

    return () => {
      window.removeEventListener("resize", handleResize);
      window
        .matchMedia("(pointer: coarse)")
        .removeEventListener("change", handlePointerChange);
    };
  }, []);

  const isMobile = deviceType === DeviceEnum.MOBILE;
  const isIpad = deviceType === DeviceEnum.IPAD;
  const isSmDesktop = deviceType === DeviceEnum.DESKTOP_SM;
  const isDesktop = deviceType === DeviceEnum.DESKTOP;
  // bigger then mobile view
  const isTablet =
    deviceType === DeviceEnum.IPAD ||
    deviceType === DeviceEnum.DESKTOP ||
    deviceType === DeviceEnum.DESKTOP_SM;

  return {
    deviceType,
    isMobile,
    isIpad,
    isSmDesktop,
    isDesktop,
    isTablet,
    isTouchDevice,
  };
};

export default useBreakPoints;
